function updateDropdownPosition() {
  const searchBar = document.querySelector('.header__heading details.tw-w-full'); // or another element
  const dropdown = document.querySelector('.wizzy-autocomplete-wrapper'); // or your correct dropdown selector

  if (searchBar && dropdown) {
    const rect = searchBar.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const topValue = scrollTop + searchBar.offsetHeight + 40 ;
     localStorage.setItem('dropdownTop', topValue);
    dropdown.style.top = `${topValue}px`;
  }
}


const dropdownTrigger = document.querySelector('.header__heading details.tw-w-full');
const searchInputfordropdown=document.querySelector('.header__heading .search__input.field__input');

if (dropdownTrigger) {
  dropdownTrigger.addEventListener('click', () => {
    
    updateDropdownPosition();
  });
}
function setDropdownTopFromLocalStorage() {
  const storedTop = localStorage.getItem('dropdownTop');
  if (!storedTop) return;

  let attempts = 0;
  const maxAttempts = 10; // Run for about 1 second (10 * 100ms)

  const interval = setInterval(() => {
    const dropdown = document.querySelector('.wizzy-autocomplete-wrapper');
    if (dropdown) {
      dropdown.style.top = `${storedTop}px`;
    }

    attempts++;
    if (attempts >= maxAttempts) {
      clearInterval(interval); // Stop after ensuring it's applied long enough
    }
  }, 100);
}

if (searchInputfordropdown) {
  searchInputfordropdown.addEventListener('click', setDropdownTopFromLocalStorage);
  searchInputfordropdown.addEventListener('input', setDropdownTopFromLocalStorage);
}





window.addEventListener('scroll', updateDropdownPosition);

const refreshTriggers = ["myborosil.com"];
let lastURL = window.location.href;

function checkAndRefreshOnBack() {
  const newURL = window.location.href;

  const shouldRefresh = refreshTriggers.some((trigger) => newURL.includes(trigger));

  if (shouldRefresh && newURL !== lastURL) {
    location.reload();
  }

  lastURL = newURL;
}

window.addEventListener("popstate", () => {
  setTimeout(checkAndRefreshOnBack, 100); // delay ensures location.href is updated
});



const detailsEl = document.querySelector('.header__heading details.tw-w-full');
const searchInput = document.querySelector('.header__heading .search__input.field__input');

if (detailsEl && searchInput) {
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
        
        if (detailsEl.hasAttribute('open')) {

          searchInput.click(); // or searchInput.focus();
        } else {
          // When details close, hide the autocomplete wrapper
          const wrapper = document.querySelector('.wizzy-autocomplete-wrapper');
          if (wrapper) {
            wrapper.style.display = 'none';
          }
        }

      }
    }
  });

  observer.observe(detailsEl, {
    attributes: true,
    attributeFilter: ['open']
  });
}

if(window.innerWidth < 768){
const detailsElmob = document.querySelector('details.tw-w-full');
const searchInputmob =  document.querySelector('.search__input');

if (detailsElmob && searchInputmob) {

  const observer1 = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      
      if (mutation.type === 'attributes' && mutation.attributeName === 'open') {

        if (detailsElmob.hasAttribute('open')) {
          searchInputmob.click(); 
        } else {
          console.log("close");

          const wrapper = document.querySelector('.wizzy-autocomplete-wrapper');
          if (wrapper) {
            wrapper.style.display = 'none';
          }
        }

      }
    }
  });

  observer1.observe(detailsElmob, {
    attributes: true,
    attributeFilter: ['open']
  });
}
}
function hideAutocompleteWrapper() {
  const el = document.querySelector('.wizzy-autocomplete-wrapper');
  if (el) el.style.display = 'none';
}



document.addEventListener('click', function (e) {
  const target = e.target.closest('.product-card__quick-add-button');
  if (target) {
    hideAutocompleteWrapper();
  }
});

document.querySelector('.search__icon .icon.icon-search').addEventListener('click', () => {
  document.querySelector('.search__input.field__input').click();
});



window.onWizzyScriptLoaded = function () {
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {

      const selectedFilters = document.querySelector('.wizzy-selected-filters');
const clearAllButton = document.querySelector('.wizzy-filters-clear-all');

if (selectedFilters && clearAllButton) {
  if (selectedFilters.children.length === 0) {
    clearAllButton.style.display = 'none';
  } else {
    clearAllButton.style.display = ''; // Or 'block' or whatever default it needs
  }
}

          

         if (window.innerWidth > 768) {
var sourceElement = document.querySelector(".wizzy-search-sort-wrapper");

      if (sourceElement) {

        var clonedContent = sourceElement.cloneNode(true);

        var targetDiv = document.querySelector(".wizzy-sort-wrapper-in-filter");

        if (
          targetDiv &&
          !targetDiv.querySelector(".wizzy-search-sort-wrapper")
        ) {
          targetDiv.appendChild(clonedContent);
        }
      }
      
   
        var sortInFilter = document.querySelector(
          ".wizzy-search-filters-left-wrapper .wizzy-common-select-selector"
        );
        if (
          sortInFilter &&
          !sortInFilter.classList.contains("click-listener-attached")
        ) {
          sortInFilter.addEventListener("click", function (event) {
            event.preventDefault();
            event.stopPropagation();
            var sortOptions = document.querySelector(
              ".wizzy-common-select-options"
            );
            if (sortOptions) {
              if (
                sortOptions.style.display === "none" ||
                sortOptions.style.display === ""
              ) {
                sortOptions.style.display = "grid";
              } else {
                sortOptions.style.display = "none";
              }
            }
          });
          sortInFilter.classList.add("click-listener-attached");
        }

//            const optionsEl = document.querySelector('.wizzy-sort-wrapper-in-filter .wizzy-common-select-options');
// const targetContainer = document.querySelector('.wizzy-sort-wrapper-in-filter .wizzy-common-select-selector.click-listener-attached');

// if (optionsEl && targetContainer) {
//   targetContainer.appendChild(optionsEl);
// }
//            var mainsortinfilterelement = document.querySelector(".wizzy-sort-wrapper-in-filter");

// if (mainsortinfilterelement) {
//   const childToRemove = mainsortinfilterelement.querySelector("[class^='wizzy-tile-view-icon-']");
//   if (childToRemove) {
//     childToRemove.remove();
//   }
// }

      }
         const gridView = document.querySelector(
        ".grid-view.tw-flex.tw-items-center.tw-gap-1.tw-cursor-pointer.active-view.wizzy-custom-list-change-two"
      );

      if (gridView) {
        gridView.classList.add("active");
      }

      return data;
    }
  );




  // window.wizzyConfig.events.registerEvent(
  //    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
  //    function (data) {

  //      return data;
  //    }
  //  );

  // Replacing default template
  replaceTemplate("wizzy-search-results-product");
  replaceTemplate("wizzy-search-sort");
  // replaceTemplate("wizzy-search-results");
  // replaceTemplate("wizzy-search-empty-results");
  // replaceTemplate("wizzy-search-wrapper");
  replaceTemplate("wizzy-autocomplete-topproducts");
  // replaceTemplate("wizzy-autocomplete-suggestions");

  function attachListViewChangeListener() {
    console.log("attach is called");
    let listViewElements = document.querySelectorAll(
        ".wizzy-custom-list-change-one, .wizzy-custom-list-change-two, .wizzy-custom-list-change-three, .wizzy-custom-list-change-four"
      ),
      len = listViewElements.length;
    for (let i = 0; i < len; i++)
      listViewElements[i].onclick ||
        (listViewElements[i].onclick = function (event) {
   
          // if ((event.preventDefault(), this.classList.contains("active")))
          //   return;
          let itemsCount = this.getAttribute("data-items"),
            oneItemsEle = document.querySelector(
              ".wizzy-custom-list-change-one"
            ),
            twoItemsEle = document.querySelector(
              ".wizzy-custom-list-change-two"
            ),
            threeItemsEle = document.querySelector(
              ".wizzy-custom-list-change-three"
            ),
            fourItemsEle = document.querySelector(
              ".wizzy-custom-list-change-four"
            );
          oneItemsEle &&
            (oneItemsEle.classList.remove("active"),
            sessionStorage.setItem("wizzy-custom-list-change-1", "false")),
            twoItemsEle &&
              (twoItemsEle.classList.remove("active"),
              sessionStorage.setItem("wizzy-custom-list-change-2", "false")),
            threeItemsEle &&
              (threeItemsEle.classList.remove("active"),
              sessionStorage.setItem("wizzy-custom-list-change-3", "false")),
            fourItemsEle &&
              (fourItemsEle.classList.remove("active"),
              sessionStorage.setItem("wizzy-custom-list-change-4", "false")),
            this.classList.add("active");
          let productsPerRow = this.getAttribute("data-items");
          sessionStorage.setItem(
            "wizzy-custom-list-change-" + productsPerRow,
            "true"
          );
          let parentWrapper = document.querySelector(".wizzy-search-wrapper");
          parentWrapper &&
            parentWrapper.setAttribute(
              "data-wizzy-products-per-row",
              productsPerRow
            );
        });
  }
  function onReloadOrCominigBackFromPDPHandleListViewChange() {
    console.log("onReload is called");
    let oneItemsEle = document.querySelector(".wizzy-custom-list-change-one"),
      twoItemsEle = document.querySelector(".wizzy-custom-list-change-two"),
      threeItemsEle = document.querySelector(".wizzy-custom-list-change-three"),
      fourItemsEle = document.querySelector(".wizzy-custom-list-change-four");
    oneItemsEle && oneItemsEle.classList.remove("active"),
      twoItemsEle && twoItemsEle.classList.remove("active"),
      threeItemsEle && threeItemsEle.classList.remove("active"),
      fourItemsEle && fourItemsEle.classList.remove("active");
    let productsPerRow = null;
    if (
      (sessionStorage.getItem("wizzy-custom-list-change-1") === "true" &&
        oneItemsEle &&
        (oneItemsEle.classList.add("active"), (productsPerRow = "1")),
      sessionStorage.getItem("wizzy-custom-list-change-2") === "true" &&
        twoItemsEle &&
        (console.log("<=====Two is fine"),
        twoItemsEle.classList.add("active"),
        (productsPerRow = "2")),
      sessionStorage.getItem("wizzy-custom-list-change-3") === "true" &&
        threeItemsEle &&
        (console.log("<=====Why  Three is fine"),
        threeItemsEle.classList.add("active"),
        (productsPerRow = "3")),
      sessionStorage.getItem("wizzy-custom-list-change-4") === "true" &&
        fourItemsEle &&
        (fourItemsEle.classList.add("active"), (productsPerRow = "4")),
      console.log(productsPerRow, "<===wizzy"),
      productsPerRow)
    ) {
      let parentWrapper = document.querySelector(".wizzy-search-wrapper");
      parentWrapper &&
        parentWrapper.setAttribute(
          "data-wizzy-products-per-row",
          productsPerRow
        );
    } else
      document.documentElement.clientWidth > 768
        ? threeItemsEle && threeItemsEle.classList.add("active")
        : twoItemsEle && twoItemsEle.classList.add("active");
    document.documentElement.clientWidth < 768 &&
      (sessionStorage.setItem("wizzy-custom-list-change-3", "false"),
      sessionStorage.setItem("wizzy-custom-list-change-4", "false"));
  }

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function (payload) {
      window.wizzyConfig.autocomplete.menu.alignment = "left";

      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (payload) {

      try {
        window.wizzyConfig.search.view.templates.facets.rangeListItem =
          "#wizzy-facet-range-list-item";
        window.wizzyConfig.search.configs.facets.configs =
          window.wizzyConfig.search.configs.facets.configs.filter(
            (facet) => facet.key !== "sellingPrice"
          );
        window.wizzyConfig.search.configs.facets.configs.push({
          label: "Price",
          buckets: [
            {
              from: 0,
              to: 500,
            },
            {
              from: 501,
              to: 1000,
            },
            {
              from: 1001,
              to: 2000,
            },
            {
              from: 2001,
              to: 3000,
            },
            {
              from: 3001,
              to: 5516,
            },
          ],
          key: "sellingPrice",
          position: "left",
          // order: 50
        });
      } catch (error) {}
      window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = true;
      payload.search.configs.facets.leftFacets.mobileCollapsible = !0;
      window.wizzyConfig.search.tileView.display = true;
      window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
        {
          dom: "wizzy-search-input",
          type: "text",
        },
      ];
      // window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers.push("#main")
      window.wizzyConfig.autocomplete.menu.alignment = "left";
      window.wizzyConfig.search.configs.facets.filtersButtonMobile.position =
        "top";
      
     payload.search.configs.facets.configs.forEach((filter) =>{
        filter.label = 'BY ' + filter.label;
      });
       payload.search.configs.facets.leftFacets.defaultCollapsed=false;

       payload.search.configs.pagination.infiniteScrollOffset = {
        desktop: 1500,
        mobile: 1750,
       };
      
      return payload;
    }
  );
    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (products) {
      products.forEach((product) => {
      
        product.attributes.forEach((attr) => {
          if (attr.id === "product_product_variant_metafield_size_custom") {
            let swatchvalue = attr.values[0].value[0];
            product.parsedArray = JSON.parse(swatchvalue);
          }
        });
      });

      return products;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (payload) {
      // console.log(payload, " <== AFTER_PRODUCTS_TRANSFORMED")

      payload.forEach((product) => {
        product.handle = "";
        product.currentSelectedSwatch = "";
        if (product.attributes) {
          product.attributes.forEach((attribute) => {
            if (attribute.id === "product_handle") {
              if (attribute.values[0].value[0]) {
                product.handle = attribute.values[0].value[0];
              }
            }
            if (attribute.id === "product_Size") {
              if (attribute.values[0].value[0]) {
                product.currentSelectedSwatch = attribute.values[0].value[0];
              }
            }
          });
        }
      });

      payload.forEach((product) => {
        // Check if the last three characters of price are '.00' and remove them if necessary
        if (product.price) {
          if (product.price.endsWith(".00")) {
            product.price = product.price.slice(0, -3); // Remove the last three characters
          }
        }
        if (product.sellingPrice) {
          if (product.sellingPrice.endsWith(".00")) {
            product.sellingPrice = product.sellingPrice.slice(0, -3); // Remove the last three characters
          }
        }
        if (product.discount) {
          if (product.discount.endsWith(".00")) {
            product.discount = product.discount.slice(0, -3); // Remove the last three characters
          }
          // var discountPrice = product.discount;
          // if(discountPrice){
          //   product.discount = discountPrice.replace(/,/g, '');
          // }
        }
      });

      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (payload) {
      // console.log(payload, "BEFORE_AUTOCOMPLETE_EXECUTED");
      // payload.minQueryLength = 1;
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER,
    function (data) {
      // console.log(data, "<====BEFORE_AUTOCOMPLETE_RENDER");
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (payload) {
      // console.log(payload,"BEFORE_AUTOCOMPLETE_EXECUTED")
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (payload) {
         if(document.querySelector('.product-media-modal.media-modal')){
        console.log("->>>>>>>>>>>>>>>>>>>>",document.querySelector('.product-media-modal.media-modal'));
     document.querySelector(localStorage.getItem("product-class")).style.display= "none";
        document.querySelector(localStorage.getItem("product-video")).style.display= "none";

      }
     
      // console.log(payload,"BEFORE_SEARCH_EXECUTED")
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (payload) {

      // console.log(payload.filters,"BEFORE_FILTERS_EXECUTED");
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
 localStorage.setItem("product-class",".product-media-modal.media-modal");
       localStorage.setItem("product-video","#quinn-floating-widget");
  //     const searchWrapper = document.querySelector(".wizzy-search-wrapper");
  // const singleView = document.getElementById("single-view");
  // const gridView = document.getElementById("grid-view");

  // function updateProductsPerRow() {
  //   if (gridView.classList.contains("active")) {
  //     searchWrapper.setAttribute("data-wizzy-products-per-row", "2");
  //   } else if (singleView.classList.contains("active")) {
  //     searchWrapper.setAttribute("data-wizzy-products-per-row", "1");
  //   }
  // }

  // updateProductsPerRow();
      
if(window.innerWidth < 768){
  const tileViewIcon = document.querySelector('.wizzy-tile-view-icon-xyz');
const resultsWrapper = document.querySelector('.wizzy-search-results-wrapper');

if (tileViewIcon && resultsWrapper) {
  resultsWrapper.insertBefore(tileViewIcon, resultsWrapper.firstChild);
}

}

      
  document.querySelectorAll('.wizzy-facet-range-list-label').forEach((item) => {
  item.innerHTML = item.innerHTML.replace(/₹(\d+)/g, '₹ $1');
});

  // Handle #single-view
const singleViewElements = document.querySelectorAll('#single-view');
const gridViewElements = document.querySelectorAll('#grid-view');
 const searchWrapper = document.querySelector(".wizzy-search-wrapper");
if (singleViewElements.length >= 2 && gridViewElements.length >= 2) {
  singleViewElements[1].addEventListener('click', () => {
    singleViewElements[0].click(); // Trigger original click
    singleViewElements[1].classList.add('active');
    gridViewElements[1].classList.remove('active'); 
     searchWrapper.setAttribute("data-wizzy-products-per-row", "1");
  });

  gridViewElements[1].addEventListener('click', () => {
    gridViewElements[0].click(); // Trigger original click
    gridViewElements[1].classList.add('active');
    singleViewElements[1].classList.remove('active');
     searchWrapper.setAttribute("data-wizzy-products-per-row", "2");
  });
}
      if(window.innerWidth > 768){
         document
        .querySelector(".wizzy-filters-header .header-title").textContent="Filters";
      }
        document
        .querySelector(".wizzy-apply-all-button-block")
        .addEventListener("click", function () {
          var closeButton = document.querySelector(".wizzy-filters-close-btn");
          if (closeButton) {
            closeButton.click();
          }
        });
       document
        .querySelector(".wizzy-filters-close-button-block")
        .addEventListener("click", function () {
          var clearAllButton = document.querySelector(
            ".wizzy-filters-close-btn"
          );
          if (clearAllButton) {
            clearAllButton.click();
          }
        });
     
           document
        .querySelector(".wizzy-filters-header .close-filter")
        .addEventListener("click", function () {
          var closeButton = document.querySelector(".wizzy-filters-close-btn");
          if (closeButton) {
            closeButton.click();
          }
        });
      // console.log(data," <= VIEW_RENDERED");
      attachListViewChangeListener();

      // Select all product variants containers /////////////////////////////////////////

      const productVariantsList = document.querySelectorAll(
        ".product-card__variants.tw-min-w-full"
      );

      function toggleDrawer(event) {
        const productVariant = event.currentTarget;
        const resultProductItemInfo = productVariant.querySelector(
          ".result-product-item-info"
        );
        resultProductItemInfo.classList.toggle("drawer-open");
        productVariantsList.forEach((variant) => {
          if (variant !== productVariant) {
            const otherResultProductItemInfo = variant.querySelector(
              ".result-product-item-info"
            );
            otherResultProductItemInfo.classList.remove("drawer-open");
          }
        });
      }

      function closeDrawerOutsideClick(event) {
        if (!event.target.closest(".product-card__variants.tw-min-w-full")) {
          productVariantsList.forEach((variant) => {
            const resultProductItemInfo = variant.querySelector(
              ".result-product-item-info"
            );
            resultProductItemInfo.classList.remove("drawer-open");
          });
        }
      }

      productVariantsList.forEach((variant) => {
        // Attach the event listener only once to each variant element
        if (!variant.hasEventListener) {
          variant.addEventListener("click", toggleDrawer);
          variant.hasEventListener = true; // Custom flag to prevent adding multiple listeners
        }
      });

      document.addEventListener("click", closeDrawerOutsideClick);

       const gridView = document.querySelector(
        ".grid-view.tw-flex.tw-items-center.tw-gap-1.tw-cursor-pointer.active-view.wizzy-custom-list-change-two"
      );

      if (gridView) {
        gridView.classList.add("active");
      }
      ///////////////////////////////////////////////

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (payload) {
      // console.log(payload,"BEFORE_RENDER_RESULTS");

      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
    function (payload) {
      console.log(payload, "PRODUCTS_RESULTS_RENDERED");
      // onReloadOrCominigBackFromPDPHandleListViewChange();
      return payload;
    }
  );


  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SORT_EXECUTED,
    function (payload) {

        // attachListViewChangeListener();
      return payload;
    });
  

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (payload) {
      if(window.innerWidth < 768){
  const tileViewIcon = document.querySelector('.wizzy-tile-view-icon-xyz');
const resultsWrapper = document.querySelector('.wizzy-search-results-wrapper');

if (tileViewIcon && resultsWrapper) {
  resultsWrapper.insertBefore(tileViewIcon, resultsWrapper.firstChild);
}

}
      onReloadOrCominigBackFromPDPHandleListViewChange();
attachListViewChangeListener();
      // Select all product variants containers /////////////////////////////////////////

      const productVariantsList = document.querySelectorAll(
        ".product-card__variants.tw-min-w-full"
      );

      function toggleDrawer(event) {
        const productVariant = event.currentTarget;
        const resultProductItemInfo = productVariant.querySelector(
          ".result-product-item-info"
        );
        resultProductItemInfo.classList.toggle("drawer-open");
        productVariantsList.forEach((variant) => {
          if (variant !== productVariant) {
            const otherResultProductItemInfo = variant.querySelector(
              ".result-product-item-info"
            );
            otherResultProductItemInfo.classList.remove("drawer-open");
          }
        });
      }

      function closeDrawerOutsideClick(event) {
        if (!event.target.closest(".product-card__variants.tw-min-w-full")) {
          productVariantsList.forEach((variant) => {
            const resultProductItemInfo = variant.querySelector(
              ".result-product-item-info"
            );
            resultProductItemInfo.classList.remove("drawer-open");
          });
        }
      }

      productVariantsList.forEach((variant) => {
        // Attach the event listener only once to each variant element
        if (!variant.hasEventListener) {
          variant.addEventListener("click", toggleDrawer);
          variant.hasEventListener = true; // Custom flag to prevent adding multiple listeners
        }
      });

      document.addEventListener("click", closeDrawerOutsideClick);


      
      ///////////////////////////////////////////////

      return payload;
    }
  );
};

// Declaration of template replace function
const replaceTemplate = (div) => {
  let newDiv = document.getElementById(div + "-new").text;
  let oldDiv = document.getElementById(div);
  oldDiv.text = newDiv;
};
